// form-config.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { FormFieldConfig } from '../conponents/dynamic-form/dynamic-form/dynamic-form.component' ;
import { DatabaseService } from './database.service';
import { environment } from './global-environment';


export interface StoredFormConfig {
  formName: string;
  companyid: string;
  assistantid: string;
  config: FormFieldConfig[];
}

@Injectable({
  providedIn: 'root'
})
export class FormConfigService {
  private apiUrl = environment.apiUrl;

  constructor(private databaseService: DatabaseService, private http: HttpClient) {}


   // 依據 formName 與 companyid 取得對應的表單配置
   getFormConfig(companyid: string, formid: string, formName: string): Observable<FormFieldConfig[]> {
    // 構建查詢參數
    let params: any = {
      companyid: companyid
    };

    // 優先使用 formid，如果沒有 formid 才使用 formName
    if (formid) {
      params.formid = formid;
    } else if (formName) {
      params.formName = formName;
    }

    // 建構 API URL
    const url = `${this.apiUrl}/api/form-manager/get_specific_form_config`;

    // 呼叫新的 API 端點
    return this.http.get<any>(url, { params }).pipe(
      map((response: any) => {
        // 檢查 API 回應是否成功
        if (response.success && response.data) {
          // 回傳表單配置
          return response.data.config || [];
        } else {
          // 如果沒有找到資料或失敗，回傳空陣列
          console.log('未找到表單配置或API回應失敗:', response.message);
          return [];
        }
      })
    );
  }


}
